import { render, staticRenderFns } from "./FormReport.vue?vue&type=template&id=4b822074"
import script from "./FormReport.vue?vue&type=script&lang=js"
export * from "./FormReport.vue?vue&type=script&lang=js"
import style0 from "./FormReport.vue?vue&type=style&index=0&id=4b822074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports